// extracted by mini-css-extract-plugin
module.exports = {"topNavbar":"DashboardNavbar_topNavbar_2jKQs","accountName":"DashboardNavbar_accountName_tU190"};